// put navigation routes here

const toPersonalPlay = (playId: string) => `/app/personal/plays/${playId}`;
const toPersonalPlayCreate = () => `/app/personal/plays/create`;
const toTeamPlay = (teamId: string, playId: string) =>
  `/app/team/${teamId}/plays/${playId}`;

export { toPersonalPlay, toTeamPlay, toPersonalPlayCreate };
